/* SNR name persistence (all pages).
   - Saves the star name typed in the hero box or any star-name field to localStorage (snr_name, snr_name2).
   - ?name= / ?name2= in the URL also saves it.
   - Pre-fills every empty star-name field ([data-snr-in="name1"|"name2"], input[name="properties[Star name]"]).
   - After an add-to-cart (snr_added=1) the field still pre-fills, with a "Using: Sarah Jayne · change" chip.
   - "change" clears the field and focuses it; "clear" forgets the saved name.
   - Every /cart/add (product form, cart drawer, quick add, fetch or plain form post) gets properties[Star name]
     from the saved name if the form didn't send one. */
(function () {
  var K = 'snr_name', K2 = 'snr_name2', KA = 'snr_added';
  function get(k) { try { return (localStorage.getItem(k) || '').trim(); } catch (e) { return ''; } }
  function set(k, v) { try { v = (v || '').trim().slice(0, 60); v ? localStorage.setItem(k, v) : localStorage.removeItem(k); } catch (e) {} }
  try { var q = new URLSearchParams(location.search); if (q.get('name')) set(K, q.get('name')); if (q.get('name2')) set(K2, q.get('name2')); } catch (e) {}
  var SEL1 = '[data-snr-in="name1"],input[name="properties[Star name]"],[data-snr-namebox] input[name="name"]';
  var SEL2 = '[data-snr-in="name2"],input[name="properties[Second star name]"]';
  function fire(i) { i.dispatchEvent(new Event('input', { bubbles: true })); i.dispatchEvent(new Event('change', { bubbles: true })); }
  function chip(inp) {
    var f = inp.closest('.snr-field') || inp.parentNode, c = f.querySelector('.snr-namechip');
    if (!c) { c = document.createElement('div'); c.className = 'snr-namechip'; c.setAttribute('role', 'status');
      c.innerHTML = '<span></span><button type="button" data-a="change">change</button><button type="button" data-a="clear">clear</button>';
      inp.insertAdjacentElement('afterend', c);
      c.addEventListener('click', function (e) { var a = e.target.getAttribute('data-a'); if (!a) return;
        if (a === 'clear') { set(K, ''); set(K2, ''); set(KA, ''); }
        inp.value = ''; fire(inp); c.hidden = true; if (a === 'clear') { broadcast(); sync(); } inp.focus(); }); }
    var v = inp.value.trim(); c.hidden = !v || v !== get(K);
    c.querySelector('span').textContent = (get(KA) ? 'Using: ' : 'Saved: ') + v;
  }
  function fill(root) {
    var n1 = get(K), n2 = get(K2);
    (root || document).querySelectorAll(SEL1).forEach(function (i) {
      var box = i.closest('[data-snr-namebox]');
      if (n1 && !i.value && !box) { i.value = n1; fire(i); }
      if (!box && i.type !== 'hidden') chip(i);
    });
    (root || document).querySelectorAll(SEL2).forEach(function (i) { if (n2 && !i.value) { i.value = n2; fire(i); } });
  }
  /* v-real: push the saved name into fields that already hold another value (other tab, chip clear, set/clear).
     Skips the field being typed in and the hero box; programmatic events don't re-save. */
  function sync() { var n1 = get(K), n2 = get(K2), a = document.activeElement;
    document.querySelectorAll(SEL1).forEach(function (i) { if (i === a) return; var box = i.closest('[data-snr-namebox]');
      if (i.value.trim() !== n1) { i.value = n1; fire(i); } if (!box && i.type !== 'hidden') chip(i); });
    document.querySelectorAll(SEL2).forEach(function (i) { if (i !== a && i.value.trim() !== n2) { i.value = n2; fire(i); } }); }
  // save while typing (hero box and any name field)
  document.addEventListener('input', function (e) {
    var t = e.target; if (!t.matches) return;
    if (t.matches(SEL1) && e.isTrusted) { set(K, t.value); var c = (t.closest('.snr-field') || t.parentNode).querySelector('.snr-namechip'); if (c) c.hidden = true; }
    else if (t.matches(SEL2) && e.isTrusted) set(K2, t.value);
  }, true);
  // hero box submit: keep the name, carry ?name=
  document.addEventListener('submit', function (e) {
    var f = e.target, i = f.querySelector && f.querySelector('[data-snr-namebox] input[name="name"],input[name="name"]');
    if (f.matches && f.matches('[data-snr-namebox]') && i) set(K, i.value);
    if (f.action && /\/cart\/add/.test(f.action)) { ensure(f); set(KA, '1'); }
  }, true);
  function ensure(f) {
    var n1 = get(K); if (!n1) return;
    var has = f.querySelector('[name="properties[Star name]"]:not([disabled])');
    if (has && has.value.trim()) return;
    if (has) { has.value = n1; return; }
    var h = document.createElement('input'); h.type = 'hidden'; h.name = 'properties[Star name]'; h.value = n1; h.setAttribute('data-snr-auto', ''); f.appendChild(h);
  }
  // fetch wrapper: cart drawer, quick add, any AJAX add
  if (window.fetch) {
    var of = window.fetch;
    window.fetch = function (url, opt) {
      var u = typeof url === 'string' ? url : (url && url.url) || '';
      if (/\/cart\/add(\.js)?(\?|$)/.test(u) && opt && opt.body) {
        var n1 = get(K);
        try {
          if (n1 && opt.body instanceof FormData) { if (!(opt.body.get('properties[Star name]') || '').trim()) opt.body.set('properties[Star name]', n1); }
          else if (n1 && typeof opt.body === 'string' && opt.body.charAt(0) === '{') {
            var j = JSON.parse(opt.body), items = j.items || [j];
            items.forEach(function (it) { it.properties = it.properties || {}; if (it.properties._addon || it.properties._skipname) return; if (!(it.properties['Star name'] || '').trim()) it.properties['Star name'] = n1; });
            opt.body = JSON.stringify(j);
          }
        } catch (e) {}
        return of.apply(this, arguments).then(function (r) { if (r.ok) { set(KA, '1'); setTimeout(function () { fill(); }, 50); } return r; });
      }
      return of.apply(this, arguments);
    };
  }
  /* v12z11: one shared example name. cur() = saved name or 'Sarah Jayne'. Every [data-snr-name] element shows it,
     and 'snr:name' fires on load, while typing (debounced) and across tabs, for renderers (hero, previews, engraving). */
  var DEF = 'Your star' /* v4b: was 'Sarah Jayne' */, bt;
  function cur() { return get(K) || DEF; }
  function broadcast() { var n = cur(), s = get(K);
    document.querySelectorAll('[data-snr-name]').forEach(function (el) { var m = el.getAttribute('data-snr-name'); var v = m === 'poss' ? n + (/s$/i.test(n) ? '’' : '’s') + ' Star' : n; if (el.hasAttribute('data-type')) el.setAttribute('data-type', v); el.textContent = m === 'poss' ? n + (/s$/i.test(n) ? '’' : '’s') + ' Star' : n; });
    document.dispatchEvent(new CustomEvent('snr:name', { detail: { name: n, saved: s } })); }
  function soon() { clearTimeout(bt); bt = setTimeout(function () { broadcast(); sync(); }, 250); }
  document.addEventListener('input', function (e) { var t = e.target; if (t.matches && t.matches(SEL1) && e.isTrusted) soon(); });
  window.addEventListener('storage', function (e) { if (e.key === K || e.key === K2 || e.key === null) { broadcast(); sync(); } });
  window.snrName = { get: function () { return get(K); }, cur: cur, DEF: DEF, set: function (v) { set(K, v); fill(); broadcast(); sync(); }, clear: function () { set(K, ''); set(K2, ''); set(KA, ''); broadcast(); sync(); } };
  function go() { fill(); broadcast(); new MutationObserver(function (m) { m.forEach(function (r) { r.addedNodes.forEach(function (n) { if (n.nodeType === 1 && n.querySelector && n.querySelector(SEL1)) fill(n); }); }); }).observe(document.body, { childList: true, subtree: true }); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', go); else go();
  /* re-fire once everything (live preview in snr.js) is bound */
  /* hero box: the browser can restore an old typed value; match the saved name instead */
  window.addEventListener('load', function () { setTimeout(function () { var n1 = get(K); document.querySelectorAll('[data-snr-namebox] input[name="name"]').forEach(function (i) { if (i !== document.activeElement && i.value.trim() !== n1) { i.value = n1; fire(i); } }); }, 300); });
  window.addEventListener('load', function () { document.querySelectorAll(SEL1 + ',' + SEL2).forEach(function (i) { if (i.value && !i.closest('[data-snr-namebox]')) fire(i); }); });
})();
/* v12: express delivery add-on is one per order (cart page guard) */
(function () {
  if (!/\/cart\/?$/.test(location.pathname) || !window.fetch) return;
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  fetch(root + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (c) {
    var ex = (c.items || []).filter(function (i) { return /^snr-addon-express/.test(i.handle || ''); });
    var fix = ex.map(function (i, n) { return { key: i.key, q: n === 0 ? 1 : 0 }; }).filter(function (x, n) { return ex[n].quantity !== x.q; });
    if (!fix.length) return;
    fix.reduce(function (p, x) { return p.then(function () { return fetch(root + 'cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: x.key, quantity: x.q }) }); }); }, Promise.resolve())
      .then(function () { location.reload(); });
  }).catch(function () {});
})();

